/* eslint-disable max-len */
// TextArea.js
import React, { useContext } from 'react';
import DocumentAuthorContext from '../../../../../context/DocumentAuthorContext';

function Radio({ component}) {
    const { componentAnswers } = useContext(DocumentAuthorContext);
    return (
        <div className={`${component.label.alignment === 'top' ? 'flex flex-col' : 'flex items-start'} cursor-default`} style={{ minWidth: "150px", width: component.styles.width }}>
            {component.label.name.trim() !== '' && 
            <div className='min-w-[120px] mr-[10px]'>
                <label style={component?.label?.styles} className={`text-[#333] cursor-default pr-2 break-all`}>{component.label.name || ''} {component.is_required && <span data-testid="is_required" className='text-[#333]'>*</span>}</label>
            </div>}
            <div className={`${component.label.alignment === 'top' ? 'mt-4' : 'mt-1.5'} ${component.styles.labelAlignment === 'left' ? 'flex items-start gap-[16px] flex-wrap' : ''}`}>
                {component.fields.map((data, index) => (
                    <div key={`${component.component_id}-${index}`} style={component.fields.length - 1 !== index ? {paddingBottom: '10px'} : {}} className={`relative custom-radioBlue flex items-start leading-none mb-2 cursor-default`}>
                        <input disabled type="radio" className="forms-authoring-radio" checked={component.value === data.value || componentAnswers[component.component_id] === data.value} 
                            id={`radio_${index}_${component.component_id}`} name={`radio_group_${component.component_id}`} value={data.value} />
                        {component.show_label === true && <label htmlFor={`radio_${index}_${component.component_id}`} style={{fontSize: component?.styles?.labelFontSize, overflowWrap: 'anywhere'}} className='ml-2 break-words'>{data.label}</label>}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Radio;